export default {
	methods: {
		displayTagBasedListAfterClearing(tag){
			console.log("Wiping display list")
			this.lists = []
			this.displayTagBasedList(tag)
		}
	}
}